// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2N9yG","bigColWidth":"Table_bigColWidth__2vY6g","biggerColWidth":"Table_biggerColWidth__2GL6Z","row":"Table_row__2akNg","col":"Table_col__dOBYc"};